import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://ndzsjfahmcflnivyxptb.supabase.co'
const supabaseKey = 'sb_publishable_7zHF_DbHEoF4unTnWyTlFw_Z5yJVaMQ'

export const supabase = createClient(supabaseUrl, supabaseKey)